module.exports = __webpack_public_path__ + "media/images/hitfun3/icon.product.default-814592b3bdc1bcdd044da626faeb066a.svg";